import logoWu from '@assets/logo-wu.svg';
import { Box } from '@mui/system';
import { layoutStyle } from '@layout/styles';

function WuLayoutMenuLogo() {
  return (
    <Box component="img" src={logoWu} width="250" alt="Wester union logo" sx={layoutStyle.wuLogo} />
  );
}

export default WuLayoutMenuLogo;
